import getOption from './getOption';

var fabric = function fabric(_ref) {
  var label = _ref.label,
      values = _ref.values,
      urlParams = _ref.urlParams;
  var param = 'fabric';
  var options = values.map(function (value) {
    return {
      ariaLabel: "Click to tilter by ".concat(value),
      value: value,
      label: value
    };
  });
  var option = urlParams.get(param) || '';
  return {
    expand: false,
    filter: function filter(_ref2, value) {
      var fabric = _ref2.fabric;
      return (fabric === null || fabric === void 0 ? void 0 : fabric.title) === value;
    },
    label: label,
    param: param,
    options: options,
    selected: getOption(options, option)
  };
};

export default fabric;